export default {"src":"https://s.sylndr.com/c-960f75c/_next/static/media/banque-misr-logo.4f7ba79c.svg","height":330,"width":800,"blurWidth":0,"blurHeight":0};